import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { hideDialog } from '../../../redux/actions/dialogs';
import { ALERT_DIALOG } from '../../../redux/constants/dialogs';
import { getDialogContextValue, isDialogVisibleSelector, } from '../../../redux/selectors';

/**
 * Alerts are urgent interruptions, requiring acknowledgement, that inform the user about a situation.
 */
const AlertDialog = ({ visible, title, message, hideDialog }) => {
  return (<Dialog
    open={visible}
    keepMounted
    onClose={hideDialog}
    aria-labelledby="alert-dialog-slide-title"
    aria-describedby="alert-dialog-slide-description"
    fullWidth
    maxWidth="sm"
  >
    <DialogTitle id="alert-dialog-slide-title">
      {title}
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-slide-description">
        {message}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={hideDialog} color="primary">
        OK
      </Button>
    </DialogActions>
  </Dialog>);
};

AlertDialog.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.any,
};

function mapStateToProps(state) {
  const context = getDialogContextValue(state);
  return {
    visible: isDialogVisibleSelector(state)(ALERT_DIALOG),
    title: context(ALERT_DIALOG, 'title'),
    message: context(ALERT_DIALOG, 'message'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    hideDialog: () => hideDialog(ALERT_DIALOG),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertDialog);



// WEBPACK FOOTER //
// ./src/components/Common/AlertDialog/index.js